var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissingInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3628 14.2693H12.9499C12.9499 14.2693 12.2354 14.2628 11.116 14.2628L8.85435 14.2693H5.44143C4.32199 14.2693 3.39368 13.341 3.39368 12.2216C3.39368 11.1021 4.32199 10.1738 5.44143 10.1738H8.85435L12.9499 10.1738L16.3628 10.1738C17.4822 10.1738 18.4105 11.1021 18.4105 12.2216C18.4105 13.341 17.4822 14.2693 16.3628 14.2693Z",
    fill: "#586F9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingInfo);
export default __webpack_public_path__ + "static/media/missing-info.496f1bc813baeb56215494a8fc273d14.svg";
export { ForwardRef as ReactComponent };